/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-special-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/common/src/pipes/date_pipe';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/i18n/tokens';
import * as import10 from '../shared/config.service';
import * as import11 from '../shared/intl.service';
import * as import12 from '../shared/notification.service';
import * as import13 from '../shared/meta.service';
import * as import14 from '../shared/utils.service';
import * as import15 from '@angular/forms/src/form_builder';
import * as import16 from '@angular/router/src/router';
import * as import17 from '../shared/content.service';
import * as import18 from '@angular/router/src/router_state';
import * as import19 from '@angular/core/src/metadata/view';
import * as import20 from '@angular/core/src/linker/component_factory';
import * as import21 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import22 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import23 from '@angular/common/src/pipes/uppercase_pipe';
import * as import24 from '@angular/core/src/linker/template_ref';
import * as import25 from '@angular/common/src/directives/ng_switch';
import * as import26 from '@angular/common/src/directives/ng_if';
import * as import27 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_directive.ngfactory';
import * as import28 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import29 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import30 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_control_name.ngfactory';
import * as import31 from '../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import32 from '../../../node_modules/@angular/forms/src/directives/reactive_directives/form_group_name.ngfactory';
import * as import33 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import34 from '@angular/core/src/linker/element_ref';
import * as import35 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import36 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import37 from '@angular/forms/src/directives/control_value_accessor';
import * as import38 from '@angular/forms/src/directives/reactive_directives/form_control_name';
import * as import39 from '@angular/forms/src/directives/ng_control';
import * as import40 from '@angular/forms/src/directives/ng_control_status';
import * as import41 from '@angular/forms/src/directives/default_value_accessor';
import * as import42 from '@angular/common/src/directives/ng_for';
import * as import43 from '@angular/forms/src/directives/reactive_directives/form_group_name';
import * as import44 from '@angular/forms/src/directives/control_container';
import * as import45 from '@angular/forms/src/directives/reactive_directives/form_group_directive';
import * as import46 from '@angular/core/src/security';
export class Wrapper_ContentSpecialEditComponent {
  context:import0.ContentSpecialEditComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any) {
    this.changed = false;
    this.context = new import0.ContentSpecialEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentSpecialEditComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentSpecialEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _DatePipe_0_4:import4.DatePipe;
  _ContentSpecialEditComponent_0_5:Wrapper_ContentSpecialEditComponent;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent_Host0,renderType_ContentSpecialEditComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentSpecialEditComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._DatePipe_0_4 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._ContentSpecialEditComponent_0_5 = new Wrapper_ContentSpecialEditComponent(this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.IntlService),this._DatePipe_0_4,this.parentInjector.get(import12.NotificationService),this.parentInjector.get(import13.MetaService),this.parentInjector.get(import14.UtilsService),this.parentInjector.get(import15.FormBuilder),this.parentInjector.get(import16.Router),this.parentInjector.get(import17.ContentService),this.parentInjector.get(import18.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentSpecialEditComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._ContentSpecialEditComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.DatePipe) && (0 === requestNodeIndex))) { return this._DatePipe_0_4; }
    if (((token === import0.ContentSpecialEditComponent) && (0 === requestNodeIndex))) { return this._ContentSpecialEditComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentSpecialEditComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._ContentSpecialEditComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentSpecialEditComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentSpecialEditComponent_Host === (null as any))) { (renderType_ContentSpecialEditComponent_Host = viewUtils.createRenderComponentType('',0,import19.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentSpecialEditComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentSpecialEditComponentNgFactory:import20.ComponentFactory<import0.ContentSpecialEditComponent> = new import20.ComponentFactory<import0.ContentSpecialEditComponent>('ng-component',viewFactory_ContentSpecialEditComponent_Host0,import0.ContentSpecialEditComponent);
const styles_ContentSpecialEditComponent:any[] = ([] as any[]);
var renderType_ContentSpecialEditComponent:import2.RenderComponentType = (null as any);
class _View_ContentSpecialEditComponent0 extends import1.AppView<import0.ContentSpecialEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgSwitch_2_3:import21.Wrapper_NgSwitch;
  _text_3:any;
  _anchor_4:any;
  /*private*/ _appEl_4:import3.AppElement;
  _TemplateRef_4_5:any;
  _NgSwitchCase_4_6:import21.Wrapper_NgSwitchCase;
  _text_5:any;
  _anchor_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _TemplateRef_6_5:any;
  _NgSwitchCase_6_6:import21.Wrapper_NgSwitchCase;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _appEl_8:import3.AppElement;
  _TemplateRef_8_5:any;
  _NgIf_8_6:import22.Wrapper_NgIf;
  _text_9:any;
  _anchor_10:any;
  /*private*/ _appEl_10:import3.AppElement;
  _TemplateRef_10_5:any;
  _NgSwitchCase_10_6:import21.Wrapper_NgSwitchCase;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _anchor_24:any;
  /*private*/ _appEl_24:import3.AppElement;
  _TemplateRef_24_5:any;
  _NgIf_24_6:import22.Wrapper_NgIf;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _pipe_date_0:import4.DatePipe;
  _pipe_uppercase_1:import23.UpperCasePipe;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent0,renderType_ContentSpecialEditComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'h1',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSwitch_2_3 = new import21.Wrapper_NgSwitch();
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_4 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_4 = new import3.AppElement(4,2,this,this._anchor_4);
    this._TemplateRef_4_5 = new import24.TemplateRef_(this._appEl_4,viewFactory_ContentSpecialEditComponent1);
    this._NgSwitchCase_4_6 = new import21.Wrapper_NgSwitchCase(this._appEl_4.vcRef,this._TemplateRef_4_5,this._NgSwitch_2_3.context);
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_6 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_6 = new import3.AppElement(6,2,this,this._anchor_6);
    this._TemplateRef_6_5 = new import24.TemplateRef_(this._appEl_6,viewFactory_ContentSpecialEditComponent2);
    this._NgSwitchCase_6_6 = new import21.Wrapper_NgSwitchCase(this._appEl_6.vcRef,this._TemplateRef_6_5,this._NgSwitch_2_3.context);
    this._text_7 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_8 = new import3.AppElement(8,2,this,this._anchor_8);
    this._TemplateRef_8_5 = new import24.TemplateRef_(this._appEl_8,viewFactory_ContentSpecialEditComponent3);
    this._NgIf_8_6 = new import22.Wrapper_NgIf(this._appEl_8.vcRef,this._TemplateRef_8_5);
    this._text_9 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._anchor_10 = this.renderer.createTemplateAnchor(this._el_2,(null as any));
    this._appEl_10 = new import3.AppElement(10,2,this,this._anchor_10);
    this._TemplateRef_10_5 = new import24.TemplateRef_(this._appEl_10,viewFactory_ContentSpecialEditComponent4);
    this._NgSwitchCase_10_6 = new import21.Wrapper_NgSwitchCase(this._appEl_10.vcRef,this._TemplateRef_10_5,this._NgSwitch_2_3.context);
    this._text_11 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._text_13 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_14 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','content'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n  ',(null as any));
    this._el_16 = import5.createRenderElement(this.renderer,this._el_14,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n    ',(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n      ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_18,'div',new import5.InlineArray2(2,'class','box'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n        ',(null as any));
    this._el_22 = import5.createRenderElement(this.renderer,this._el_20,'div',new import5.InlineArray2(2,'class','box-body'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n\n          ',(null as any));
    this._anchor_24 = this.renderer.createTemplateAnchor(this._el_22,(null as any));
    this._appEl_24 = new import3.AppElement(24,22,this,this._anchor_24);
    this._TemplateRef_24_5 = new import24.TemplateRef_(this._appEl_24,viewFactory_ContentSpecialEditComponent5);
    this._NgIf_24_6 = new import22.Wrapper_NgIf(this._appEl_24.vcRef,this._TemplateRef_24_5);
    this._text_25 = this.renderer.createText(this._el_22,'\n\n\n        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_20,'\n        ',(null as any));
    this._text_27 = this.renderer.createText(this._el_20,'\n      ',(null as any));
    this._text_28 = this.renderer.createText(this._el_18,'\n    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_16,'\n  ',(null as any));
    this._text_30 = this.renderer.createText(this._el_14,'\n',(null as any));
    this._pipe_date_0 = new import4.DatePipe(this.parentInjector.get(import9.LOCALE_ID));
    this._pipe_uppercase_1 = new import23.UpperCasePipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._anchor_4,
      this._text_5,
      this._anchor_6,
      this._text_7,
      this._anchor_8,
      this._text_9,
      this._anchor_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._anchor_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.TemplateRef) && (4 === requestNodeIndex))) { return this._TemplateRef_4_5; }
    if (((token === import25.NgSwitchCase) && (4 === requestNodeIndex))) { return this._NgSwitchCase_4_6.context; }
    if (((token === import24.TemplateRef) && (6 === requestNodeIndex))) { return this._TemplateRef_6_5; }
    if (((token === import25.NgSwitchCase) && (6 === requestNodeIndex))) { return this._NgSwitchCase_6_6.context; }
    if (((token === import24.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import26.NgIf) && (8 === requestNodeIndex))) { return this._NgIf_8_6.context; }
    if (((token === import24.TemplateRef) && (10 === requestNodeIndex))) { return this._TemplateRef_10_5; }
    if (((token === import25.NgSwitchCase) && (10 === requestNodeIndex))) { return this._NgSwitchCase_10_6.context; }
    if (((token === import25.NgSwitch) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._NgSwitch_2_3.context; }
    if (((token === import24.TemplateRef) && (24 === requestNodeIndex))) { return this._TemplateRef_24_5; }
    if (((token === import26.NgIf) && (24 === requestNodeIndex))) { return this._NgIf_24_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.action;
    this._NgSwitch_2_3.check_ngSwitch(currVal_2_0_0,throwOnChange,false);
    this._NgSwitch_2_3.detectChangesInInputProps(this,this._el_2,throwOnChange);
    const currVal_4_0_0:any = 'add';
    this._NgSwitchCase_4_6.check_ngSwitchCase(currVal_4_0_0,throwOnChange,false);
    this._NgSwitchCase_4_6.detectChangesInInputProps(this,this._anchor_4,throwOnChange);
    const currVal_6_0_0:any = 'update';
    this._NgSwitchCase_6_6.check_ngSwitchCase(currVal_6_0_0,throwOnChange,false);
    this._NgSwitchCase_6_6.detectChangesInInputProps(this,this._anchor_6,throwOnChange);
    const currVal_8_0_0:any = (this.context.content && (this.context.action == 'update'));
    this._NgIf_8_6.check_ngIf(currVal_8_0_0,throwOnChange,false);
    this._NgIf_8_6.detectChangesInInputProps(this,this._anchor_8,throwOnChange);
    const currVal_10_0_0:any = 'update';
    this._NgSwitchCase_10_6.check_ngSwitchCase(currVal_10_0_0,throwOnChange,false);
    this._NgSwitchCase_10_6.detectChangesInInputProps(this,this._anchor_10,throwOnChange);
    const currVal_24_0_0:any = (this.context.content || (this.context.action == 'add'));
    this._NgIf_24_6.check_ngIf(currVal_24_0_0,throwOnChange,false);
    this._NgIf_24_6.detectChangesInInputProps(this,this._anchor_24,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_2_3.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentSpecialEditComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentSpecialEditComponent> {
  if ((renderType_ContentSpecialEditComponent === (null as any))) { (renderType_ContentSpecialEditComponent = viewUtils.createRenderComponentType('',0,import19.ViewEncapsulation.None,styles_ContentSpecialEditComponent,{})); }
  return new _View_ContentSpecialEditComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent1,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Parmi les interprètes d\'ajourd\'hui (nouveau)',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentSpecialEditComponent1(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent2,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'Parmi les interprètes d\'ajourd\'hui ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_4:any = import5.interpolate(1,'',((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.cid),'');
    if (import5.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentSpecialEditComponent2(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent3,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','lLink'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','btn btn-default btn-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Supprimer',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.deleteContent('special',this.parent.context.content._id)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentSpecialEditComponent3(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_date_0_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent4,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_date_0_0 = import5.pureProxy2((<_View_ContentSpecialEditComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentSpecialEditComponent0>this.parent)._pipe_date_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import5.interpolate(1,'(modifié: ',valUnwrapper.unwrap(import5.castByValue(this._pipe_date_0_0,(<_View_ContentSpecialEditComponent0>this.parent)._pipe_date_0.transform)(((this.parent.context.content == (null as any))? (null as any): this.parent.context.content.update_date),'dd MMM yyyy')),')');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentSpecialEditComponent4(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _FormGroupDirective_0_3:import27.Wrapper_FormGroupDirective;
  _ControlContainer_0_4:any;
  _NgControlStatusGroup_0_5:import28.Wrapper_NgControlStatusGroup;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _CheckboxControlValueAccessor_13_3:import29.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_13_4:any[];
  _FormControlName_13_5:import30.Wrapper_FormControlName;
  _NgControl_13_6:any;
  _NgControlStatus_13_7:import28.Wrapper_NgControlStatus;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _el_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _DefaultValueAccessor_24_3:import31.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_24_4:any[];
  _FormControlName_24_5:import30.Wrapper_FormControlName;
  _NgControl_24_6:any;
  _NgControlStatus_24_7:import28.Wrapper_NgControlStatus;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _DefaultValueAccessor_32_3:import31.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_32_4:any[];
  _FormControlName_32_5:import30.Wrapper_FormControlName;
  _NgControl_32_6:any;
  _NgControlStatus_32_7:import28.Wrapper_NgControlStatus;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _FormGroupName_52_3:import32.Wrapper_FormGroupName;
  _ControlContainer_52_4:any;
  _NgControlStatusGroup_52_5:import28.Wrapper_NgControlStatusGroup;
  _text_53:any;
  _anchor_54:any;
  /*private*/ _appEl_54:import3.AppElement;
  _TemplateRef_54_5:any;
  _NgFor_54_6:import33.Wrapper_NgFor;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  _FormGroupName_63_3:import32.Wrapper_FormGroupName;
  _ControlContainer_63_4:any;
  _NgControlStatusGroup_63_5:import28.Wrapper_NgControlStatusGroup;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _appEl_65:import3.AppElement;
  _TemplateRef_65_5:any;
  _NgFor_65_6:import33.Wrapper_NgFor;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _FormGroupName_74_3:import32.Wrapper_FormGroupName;
  _ControlContainer_74_4:any;
  _NgControlStatusGroup_74_5:import28.Wrapper_NgControlStatusGroup;
  _text_75:any;
  _anchor_76:any;
  /*private*/ _appEl_76:import3.AppElement;
  _TemplateRef_76_5:any;
  _NgFor_76_6:import33.Wrapper_NgFor;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _text_82:any;
  _text_83:any;
  /*private*/ _expr_120:any;
  /*private*/ _expr_121:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent5,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_120 = import8.UNINITIALIZED;
    this._expr_121 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'form',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._FormGroupDirective_0_3 = new import27.Wrapper_FormGroupDirective((null as any),(null as any));
    this._ControlContainer_0_4 = this._FormGroupDirective_0_3.context;
    this._NgControlStatusGroup_0_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
    this._text_1 = this.renderer.createText(this._el_0,'\n\n            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','panel panel-default'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'Métadonnées',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_7 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                ',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,this._el_7,'div',new import5.InlineArray2(2,'class','form-inline'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','col-md-1 col-sm-1 input-group switch material-switch'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_11,'input',new import5.InlineArray8(8,'formControlName','active','id','act','name','act','type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_13_3 = new import29.Wrapper_CheckboxControlValueAccessor(this.renderer,new import34.ElementRef(this._el_13));
    this._NG_VALUE_ACCESSOR_13_4 = [this._CheckboxControlValueAccessor_13_3.context];
    this._FormControlName_13_5 = new import30.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_13_4);
    this._NgControl_13_6 = this._FormControlName_13_5.context;
    this._NgControlStatus_13_7 = new import28.Wrapper_NgControlStatus(this._NgControl_13_6);
    this._text_14 = this.renderer.createText(this._el_11,'\n                        ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_11,'label',new import5.InlineArray4(4,'class','label-primary','for','act'),(null as any));
    this._text_16 = this.renderer.createText(this._el_11,'\n                  ',(null as any));
    this._text_17 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray4(4,'class','input-group col-lg-3 col-md-4 col-sm-5','style','max-width: 200px'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._el_20 = import5.createRenderElement(this.renderer,this._el_18,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_21 = import5.createRenderElement(this.renderer,this._el_20,'i',new import5.InlineArray2(2,'class','fa fa-calendar'),(null as any));
    this._text_22 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._text_23 = this.renderer.createText(this._el_18,'\n                    ',(null as any));
    this._el_24 = import5.createRenderElement(this.renderer,this._el_18,'input',new import5.InlineArray8(6,'class','form-control','formControlName','date','type','text'),(null as any));
    this._DefaultValueAccessor_24_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer,new import34.ElementRef(this._el_24));
    this._NG_VALUE_ACCESSOR_24_4 = [this._DefaultValueAccessor_24_3.context];
    this._FormControlName_24_5 = new import30.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_24_4);
    this._NgControl_24_6 = this._FormControlName_24_5.context;
    this._NgControlStatus_24_7 = new import28.Wrapper_NgControlStatus(this._NgControl_24_6);
    this._text_25 = this.renderer.createText(this._el_18,'\n                  ',(null as any));
    this._text_26 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._el_27 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','input-group col-lg-7 col-md-7 col-sm-10'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                      ',(null as any));
    this._el_29 = import5.createRenderElement(this.renderer,this._el_27,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._el_30 = import5.createRenderElement(this.renderer,this._el_29,'i',new import5.InlineArray2(2,'class','fa fa-external-link'),(null as any));
    this._text_31 = this.renderer.createText(this._el_27,'\n                      ',(null as any));
    this._el_32 = import5.createRenderElement(this.renderer,this._el_27,'input',new import5.InlineArray8(8,'class','form-control','formControlName','url','readonly','','type','text'),(null as any));
    this._DefaultValueAccessor_32_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer,new import34.ElementRef(this._el_32));
    this._NG_VALUE_ACCESSOR_32_4 = [this._DefaultValueAccessor_32_3.context];
    this._FormControlName_32_5 = new import30.Wrapper_FormControlName(this._ControlContainer_0_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_32_4);
    this._NgControl_32_6 = this._FormControlName_32_5.context;
    this._NgControlStatus_32_7 = new import28.Wrapper_NgControlStatus(this._NgControl_32_6);
    this._text_33 = this.renderer.createText(this._el_27,'\n                    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_9,'\n                  ',(null as any));
    this._text_35 = this.renderer.createText(this._el_9,'\n                ',(null as any));
    this._text_36 = this.renderer.createText(this._el_7,'\n              ',(null as any));
    this._text_37 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_38 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'Image',(null as any));
    this._text_40 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_41 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                  ',(null as any));
    this._text_43 = this.renderer.createText(this._el_41,'\n                  ',(null as any));
    this._el_44 = import5.createRenderElement(this.renderer,this._el_41,'img',new import5.InlineArray2(2,'width','350px'),(null as any));
    this._text_45 = this.renderer.createText(this._el_41,'\n              ',(null as any));
    this._text_46 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_47 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'Titre',(null as any));
    this._text_49 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_50 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'\n                ',(null as any));
    this._el_52 = import5.createRenderElement(this.renderer,this._el_50,'div',new import5.InlineArray4(4,'class','form-inline','formGroupName','title'),(null as any));
    this._FormGroupName_52_3 = new import32.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_52_4 = this._FormGroupName_52_3.context;
    this._NgControlStatusGroup_52_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_52_4);
    this._text_53 = this.renderer.createText(this._el_52,'\n                  ',(null as any));
    this._anchor_54 = this.renderer.createTemplateAnchor(this._el_52,(null as any));
    this._appEl_54 = new import3.AppElement(54,52,this,this._anchor_54);
    this._TemplateRef_54_5 = new import24.TemplateRef_(this._appEl_54,viewFactory_ContentSpecialEditComponent6);
    this._NgFor_54_6 = new import33.Wrapper_NgFor(this._appEl_54.vcRef,this._TemplateRef_54_5,this.parent.parentInjector.get(import35.IterableDiffers),this.parent.ref);
    this._text_55 = this.renderer.createText(this._el_52,'\n                ',(null as any));
    this._text_56 = this.renderer.createText(this._el_50,'\n              ',(null as any));
    this._text_57 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_58 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'Sous-titre',(null as any));
    this._text_60 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_61 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                ',(null as any));
    this._el_63 = import5.createRenderElement(this.renderer,this._el_61,'div',new import5.InlineArray4(4,'class','form-inline','formGroupName','subtitle'),(null as any));
    this._FormGroupName_63_3 = new import32.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_63_4 = this._FormGroupName_63_3.context;
    this._NgControlStatusGroup_63_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_63_4);
    this._text_64 = this.renderer.createText(this._el_63,'\n                  ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_63,(null as any));
    this._appEl_65 = new import3.AppElement(65,63,this,this._anchor_65);
    this._TemplateRef_65_5 = new import24.TemplateRef_(this._appEl_65,viewFactory_ContentSpecialEditComponent7);
    this._NgFor_65_6 = new import33.Wrapper_NgFor(this._appEl_65.vcRef,this._TemplateRef_65_5,this.parent.parentInjector.get(import35.IterableDiffers),this.parent.ref);
    this._text_66 = this.renderer.createText(this._el_63,'\n                ',(null as any));
    this._text_67 = this.renderer.createText(this._el_61,'\n              ',(null as any));
    this._text_68 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_69 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-heading'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'Contenu',(null as any));
    this._text_71 = this.renderer.createText(this._el_2,'\n              ',(null as any));
    this._el_72 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','panel-body'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'\n                ',(null as any));
    this._el_74 = import5.createRenderElement(this.renderer,this._el_72,'div',new import5.InlineArray2(2,'formGroupName','content'),(null as any));
    this._FormGroupName_74_3 = new import32.Wrapper_FormGroupName(this._ControlContainer_0_4,(null as any),(null as any));
    this._ControlContainer_74_4 = this._FormGroupName_74_3.context;
    this._NgControlStatusGroup_74_5 = new import28.Wrapper_NgControlStatusGroup(this._ControlContainer_74_4);
    this._text_75 = this.renderer.createText(this._el_74,'\n                  ',(null as any));
    this._anchor_76 = this.renderer.createTemplateAnchor(this._el_74,(null as any));
    this._appEl_76 = new import3.AppElement(76,74,this,this._anchor_76);
    this._TemplateRef_76_5 = new import24.TemplateRef_(this._appEl_76,viewFactory_ContentSpecialEditComponent8);
    this._NgFor_76_6 = new import33.Wrapper_NgFor(this._appEl_76.vcRef,this._TemplateRef_76_5,this.parent.parentInjector.get(import35.IterableDiffers),this.parent.ref);
    this._text_77 = this.renderer.createText(this._el_74,'\n                ',(null as any));
    this._text_78 = this.renderer.createText(this._el_72,'\n              ',(null as any));
    this._text_79 = this.renderer.createText(this._el_2,'\n\n              ',(null as any));
    this._el_80 = import5.createRenderElement(this.renderer,this._el_2,'button',new import5.InlineArray4(4,'class','btn btn-info pull-right','type','submit'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n        Sauvegarder\n      ',(null as any));
    this._text_82 = this.renderer.createText(this._el_2,'\n\n            ',(null as any));
    this._text_83 = this.renderer.createText(this._el_0,'\n\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'ngSubmit',this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_0,'submit',this.eventHandler(this._handle_submit_0_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_0,'reset',this.eventHandler(this._handle_reset_0_2.bind(this)));
    const subscription_0:any = this._FormGroupDirective_0_3.context.ngSubmit.subscribe(this.eventHandler(this._handle_ngSubmit_0_0.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_13,'change',this.eventHandler(this._handle_change_13_0.bind(this)));
    var disposable_4:Function = this.renderer.listen(this._el_13,'blur',this.eventHandler(this._handle_blur_13_1.bind(this)));
    var disposable_5:Function = this.renderer.listen(this._el_24,'input',this.eventHandler(this._handle_input_24_0.bind(this)));
    var disposable_6:Function = this.renderer.listen(this._el_24,'blur',this.eventHandler(this._handle_blur_24_1.bind(this)));
    var disposable_7:Function = this.renderer.listen(this._el_32,'input',this.eventHandler(this._handle_input_32_0.bind(this)));
    var disposable_8:Function = this.renderer.listen(this._el_32,'blur',this.eventHandler(this._handle_blur_32_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._anchor_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._anchor_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._text_82,
      this._text_83
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import36.CheckboxControlValueAccessor) && (13 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_13_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (13 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_13_4; }
    if (((token === import38.FormControlName) && (13 === requestNodeIndex))) { return this._FormControlName_13_5.context; }
    if (((token === import39.NgControl) && (13 === requestNodeIndex))) { return this._NgControl_13_6; }
    if (((token === import40.NgControlStatus) && (13 === requestNodeIndex))) { return this._NgControlStatus_13_7.context; }
    if (((token === import41.DefaultValueAccessor) && (24 === requestNodeIndex))) { return this._DefaultValueAccessor_24_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (24 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_24_4; }
    if (((token === import38.FormControlName) && (24 === requestNodeIndex))) { return this._FormControlName_24_5.context; }
    if (((token === import39.NgControl) && (24 === requestNodeIndex))) { return this._NgControl_24_6; }
    if (((token === import40.NgControlStatus) && (24 === requestNodeIndex))) { return this._NgControlStatus_24_7.context; }
    if (((token === import41.DefaultValueAccessor) && (32 === requestNodeIndex))) { return this._DefaultValueAccessor_32_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (32 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_32_4; }
    if (((token === import38.FormControlName) && (32 === requestNodeIndex))) { return this._FormControlName_32_5.context; }
    if (((token === import39.NgControl) && (32 === requestNodeIndex))) { return this._NgControl_32_6; }
    if (((token === import40.NgControlStatus) && (32 === requestNodeIndex))) { return this._NgControlStatus_32_7.context; }
    if (((token === import24.TemplateRef) && (54 === requestNodeIndex))) { return this._TemplateRef_54_5; }
    if (((token === import42.NgFor) && (54 === requestNodeIndex))) { return this._NgFor_54_6.context; }
    if (((token === import43.FormGroupName) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._FormGroupName_52_3.context; }
    if (((token === import44.ControlContainer) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._ControlContainer_52_4; }
    if (((token === import40.NgControlStatusGroup) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._NgControlStatusGroup_52_5.context; }
    if (((token === import24.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import42.NgFor) && (65 === requestNodeIndex))) { return this._NgFor_65_6.context; }
    if (((token === import43.FormGroupName) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 66)))) { return this._FormGroupName_63_3.context; }
    if (((token === import44.ControlContainer) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 66)))) { return this._ControlContainer_63_4; }
    if (((token === import40.NgControlStatusGroup) && ((63 <= requestNodeIndex) && (requestNodeIndex <= 66)))) { return this._NgControlStatusGroup_63_5.context; }
    if (((token === import24.TemplateRef) && (76 === requestNodeIndex))) { return this._TemplateRef_76_5; }
    if (((token === import42.NgFor) && (76 === requestNodeIndex))) { return this._NgFor_76_6.context; }
    if (((token === import43.FormGroupName) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) { return this._FormGroupName_74_3.context; }
    if (((token === import44.ControlContainer) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) { return this._ControlContainer_74_4; }
    if (((token === import40.NgControlStatusGroup) && ((74 <= requestNodeIndex) && (requestNodeIndex <= 77)))) { return this._NgControlStatusGroup_74_5.context; }
    if (((token === import45.FormGroupDirective) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 83)))) { return this._FormGroupDirective_0_3.context; }
    if (((token === import44.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 83)))) { return this._ControlContainer_0_4; }
    if (((token === import40.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 83)))) { return this._NgControlStatusGroup_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.parent.context.specialForm;
    this._FormGroupDirective_0_3.check_form(currVal_0_0_0,throwOnChange,false);
    this._FormGroupDirective_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInInputProps(this,this._el_13,throwOnChange);
    const currVal_13_1_0:any = 'active';
    this._FormControlName_13_5.check_name(currVal_13_1_0,throwOnChange,false);
    this._FormControlName_13_5.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInInputProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_24_3.detectChangesInInputProps(this,this._el_24,throwOnChange);
    const currVal_24_1_0:any = 'date';
    this._FormControlName_24_5.check_name(currVal_24_1_0,throwOnChange,false);
    this._FormControlName_24_5.detectChangesInInputProps(this,this._el_24,throwOnChange);
    this._NgControlStatus_24_7.detectChangesInInputProps(this,this._el_24,throwOnChange);
    this._DefaultValueAccessor_32_3.detectChangesInInputProps(this,this._el_32,throwOnChange);
    const currVal_32_1_0:any = 'url';
    this._FormControlName_32_5.check_name(currVal_32_1_0,throwOnChange,false);
    this._FormControlName_32_5.detectChangesInInputProps(this,this._el_32,throwOnChange);
    this._NgControlStatus_32_7.detectChangesInInputProps(this,this._el_32,throwOnChange);
    const currVal_52_0_0:any = 'title';
    this._FormGroupName_52_3.check_name(currVal_52_0_0,throwOnChange,false);
    this._FormGroupName_52_3.detectChangesInInputProps(this,this._el_52,throwOnChange);
    this._NgControlStatusGroup_52_5.detectChangesInInputProps(this,this._el_52,throwOnChange);
    const currVal_54_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_54_6.check_ngForOf(currVal_54_0_0,throwOnChange,false);
    this._NgFor_54_6.detectChangesInInputProps(this,this._anchor_54,throwOnChange);
    const currVal_63_0_0:any = 'subtitle';
    this._FormGroupName_63_3.check_name(currVal_63_0_0,throwOnChange,false);
    this._FormGroupName_63_3.detectChangesInInputProps(this,this._el_63,throwOnChange);
    this._NgControlStatusGroup_63_5.detectChangesInInputProps(this,this._el_63,throwOnChange);
    const currVal_65_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_65_6.check_ngForOf(currVal_65_0_0,throwOnChange,false);
    this._NgFor_65_6.detectChangesInInputProps(this,this._anchor_65,throwOnChange);
    const currVal_74_0_0:any = 'content';
    this._FormGroupName_74_3.check_name(currVal_74_0_0,throwOnChange,false);
    this._FormGroupName_74_3.detectChangesInInputProps(this,this._el_74,throwOnChange);
    this._NgControlStatusGroup_74_5.detectChangesInInputProps(this,this._el_74,throwOnChange);
    const currVal_76_0_0:any = ((this.parent.context.config.data == (null as any))? (null as any): this.parent.context.config.data.APP.LANGUAGES.SUPPORTED);
    this._NgFor_76_6.check_ngForOf(currVal_76_0_0,throwOnChange,false);
    this._NgFor_76_6.detectChangesInInputProps(this,this._anchor_76,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._FormGroupDirective_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgControlStatusGroup_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._CheckboxControlValueAccessor_13_3.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._FormControlName_13_5.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._NgControlStatus_13_7.detectChangesInHostProps(this,this._el_13,throwOnChange);
    this._DefaultValueAccessor_24_3.detectChangesInHostProps(this,this._el_24,throwOnChange);
    this._FormControlName_24_5.detectChangesInHostProps(this,this._el_24,throwOnChange);
    this._NgControlStatus_24_7.detectChangesInHostProps(this,this._el_24,throwOnChange);
    this._DefaultValueAccessor_32_3.detectChangesInHostProps(this,this._el_32,throwOnChange);
    this._FormControlName_32_5.detectChangesInHostProps(this,this._el_32,throwOnChange);
    this._NgControlStatus_32_7.detectChangesInHostProps(this,this._el_32,throwOnChange);
    const currVal_120:any = this.parent.context.image;
    if (import5.checkBinding(throwOnChange,this._expr_120,currVal_120)) {
      this.renderer.setElementProperty(this._el_44,'src',this.viewUtils.sanitizer.sanitize(import46.SecurityContext.URL,currVal_120));
      this._expr_120 = currVal_120;
    }
    this._FormGroupName_52_3.detectChangesInHostProps(this,this._el_52,throwOnChange);
    this._NgControlStatusGroup_52_5.detectChangesInHostProps(this,this._el_52,throwOnChange);
    this._FormGroupName_63_3.detectChangesInHostProps(this,this._el_63,throwOnChange);
    this._NgControlStatusGroup_63_5.detectChangesInHostProps(this,this._el_63,throwOnChange);
    this._FormGroupName_74_3.detectChangesInHostProps(this,this._el_74,throwOnChange);
    this._NgControlStatusGroup_74_5.detectChangesInHostProps(this,this._el_74,throwOnChange);
    const currVal_121:boolean = !this.parent.context.specialForm.valid;
    if (import5.checkBinding(throwOnChange,this._expr_121,currVal_121)) {
      this.renderer.setElementProperty(this._el_80,'disabled',currVal_121);
      this._expr_121 = currVal_121;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_13_5.context.ngOnDestroy();
    this._FormControlName_24_5.context.ngOnDestroy();
    this._FormControlName_32_5.context.ngOnDestroy();
  }
  private _handle_ngSubmit_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.context.onSubmit()) !== false);
    return (true && pd_0_0);
  }
  private _handle_submit_0_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onSubmit($event)) !== false);
    return (true && pd_0_0);
  }
  private _handle_reset_0_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this._FormGroupDirective_0_3.context.onReset()) !== false);
    return (true && pd_0_0);
  }
  private _handle_change_13_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_13_0);
  }
  private _handle_blur_13_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_13_0:any = ((<any>this._CheckboxControlValueAccessor_13_3.context.onTouched()) !== false);
    return (true && pd_13_0);
  }
  private _handle_input_24_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_24_0:any = ((<any>this._DefaultValueAccessor_24_3.context.onChange($event.target.value)) !== false);
    return (true && pd_24_0);
  }
  private _handle_blur_24_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_24_0:any = ((<any>this._DefaultValueAccessor_24_3.context.onTouched()) !== false);
    return (true && pd_24_0);
  }
  private _handle_input_32_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_32_0:any = ((<any>this._DefaultValueAccessor_32_3.context.onChange($event.target.value)) !== false);
    return (true && pd_32_0);
  }
  private _handle_blur_32_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_32_0:any = ((<any>this._DefaultValueAccessor_32_3.context.onTouched()) !== false);
    return (true && pd_32_0);
  }
}
function viewFactory_ContentSpecialEditComponent5(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import31.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import30.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import28.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent6,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-6 input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon max-width-20'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer,new import34.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import30.Wrapper_FormControlName((<_View_ContentSpecialEditComponent5>this.parent)._ControlContainer_52_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import28.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_0 = import5.pureProxy1((<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import38.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import39.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_0,(<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentSpecialEditComponent6(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import31.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import30.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import28.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent7,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-6 input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon max-width-20'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer,new import34.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import30.Wrapper_FormControlName((<_View_ContentSpecialEditComponent5>this.parent)._ControlContainer_63_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import28.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_1 = import5.pureProxy1((<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import38.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import39.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_1,(<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentSpecialEditComponent7(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialEditComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import31.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlName_5_5:import30.Wrapper_FormControlName;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import28.Wrapper_NgControlStatus;
  _text_6:any;
  /*private*/ _expr_12:any;
  _pipe_uppercase_1_2:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialEditComponent8,renderType_ContentSpecialEditComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_12 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','input-group'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','input-group-addon'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_0,'input',new import5.InlineArray4(4,'class','form-control','type','text'),(null as any));
    this._DefaultValueAccessor_5_3 = new import31.Wrapper_DefaultValueAccessor(this.renderer,new import34.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlName_5_5 = new import30.Wrapper_FormControlName((<_View_ContentSpecialEditComponent5>this.parent)._ControlContainer_74_4,(null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlName_5_5.context;
    this._NgControlStatus_5_7 = new import28.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n                  ',(null as any));
    this._pipe_uppercase_1_2 = import5.pureProxy1((<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1.transform.bind((<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1));
    var disposable_0:Function = this.renderer.listen(this._el_5,'input',this.eventHandler(this._handle_input_5_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'blur',this.eventHandler(this._handle_blur_5_1.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import41.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import37.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import38.FormControlName) && (5 === requestNodeIndex))) { return this._FormControlName_5_5.context; }
    if (((token === import39.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import40.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.$implicit;
    this._FormControlName_5_5.check_name(currVal_5_1_0,throwOnChange,false);
    this._FormControlName_5_5.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInInputProps(this,this._el_5,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_12:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_uppercase_1_2,(<_View_ContentSpecialEditComponent0>this.parent.parent)._pipe_uppercase_1.transform)(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_12,currVal_12))) {
      this.renderer.setText(this._text_3,currVal_12);
      this._expr_12 = currVal_12;
    }
    this._DefaultValueAccessor_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._FormControlName_5_5.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.detectChangesInHostProps(this,this._el_5,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._FormControlName_5_5.context.ngOnDestroy();
  }
  private _handle_input_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onChange($event.target.value)) !== false);
    return (true && pd_5_0);
  }
  private _handle_blur_5_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this._DefaultValueAccessor_5_3.context.onTouched()) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_ContentSpecialEditComponent8(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialEditComponent8(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-special-edit.component.ngfactory.ts